import { useToast } from 'vuestic-ui'
const { init } = useToast()

/** Validation */
export const validators = {
  email: (v: string) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return pattern.test(v.trim()) || '请输入有效的电子邮件地址'
  },
  required: (v: any) => {
    if (Array.isArray(v)) {
      return v.some((item) => item !== '') || '请至少选择一个有效的选项'
    }
    if (typeof v === 'string') {
      return v.trim().length > 0 || '该字段为必填项'
    }
    return !!v || '该字段为必填项'
  },
  maxLength: (max: number) => (v: string) => {
    return v.trim().length <= max || `不能超过${max}个字符`
  },
  int: (v: any) => {
    return /^[1-9]\d*$/.test(String(v).trim()) || '请输入正整数'
  },
}

export function return_token() {
  return localStorage.getItem('risk-access-token')
}

export function permissions() {
  return JSON.parse(localStorage.getItem('risk-permissions') || '{}')
}

export function ts_to_datetime(ts) {
  if (ts) {
    return new Date(ts * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' })
  } else {
    return null
  }
}

export function handleErrorResponse(error) {
  console.log('error!', error)
  if (error.response?.status === 401) {
    window.location.href = '/auth/login'
  } else if (error.response?.status === 422) {
    const firstError = error.response?.data?.detail?.[0]
    const errorMessage = firstError?.msg ?? 'Invalid data provided'
    init({ message: errorMessage, color: 'danger' })
  } else {
    const errorMessage = error.response?.data?.message ?? error.response?.data ?? 'An error occurred'
    const messageString = typeof errorMessage === 'object' ? JSON.stringify(errorMessage) : String(errorMessage)
    init({ message: messageString, color: 'danger' })
  }
}
